import { PropsWithChildren, ReactNode, Ref, Suspense } from "react"

interface Props {
  fallback: ReactNode
  className?: string
  ref?: Ref<HTMLDivElement>
}

export const RegionWrapper = ({
  fallback,
  children,
  className,
  ref,
}: PropsWithChildren<Props>) => (
  <div className={`h-full bg-primary select-none ${className ?? ""}`} ref={ref}>
    <Suspense fallback={fallback}>{children}</Suspense>
  </div>
)
